export default __webpack_public_path__ + "static/media/logout.69c71e07.svg";